module.exports = __webpack_public_path__ + "img/Rectangle 23.c0121947.png";